
export enum RefineryStatus {
  draft = 0,
  design = 1,
  building = 2,
  designValidated = 3,
  pipelinesVerified = 4,
  refineryTested = 5,
  production = 6
}

export class RefineryStatusUtil {
    static toString(refineryStatus: RefineryStatus): string {
        switch (refineryStatus) {
          case RefineryStatus.draft:
            return 'Draft';

          case RefineryStatus.design:
            return 'Design';

          case RefineryStatus.building:
            return 'Building';

          case RefineryStatus.designValidated:
            return 'Design Validated';

          case RefineryStatus.pipelinesVerified:
            return 'Pipelines Verified';
  
          case RefineryStatus.refineryTested:
            return 'Refinery Tested';
    
          case RefineryStatus.production:
            return 'Production';
    
          default:
            return 'Unknown';
        }
      }
}
